module.exports = __webpack_public_path__ + "img/ilutration_mic.01f3ba44.png";